export default __webpack_public_path__ + "static/media/google.750cb74f.png";